angular.module('impactx.login').controller('CustomLoginCtrl', [
    '$scope',
    'LoginService',
    '$routeParams',
    'cookieService',
    '$redirect',
    'BrowserSettings',
    'AppConfiguration',
    'LegalLinking',
    '$config',
    '$context',
    '$workspace',
    '$mdDialog',
    'ixaUserActions',
    'dataGen',
    '$location',
    'TranslationService',
    CustomLoginCtrl
]);

function CustomLoginCtrl($scope, LoginService, $routeParams, cookieService, $redirect, BrowserSettings, AppConfiguration, LegalLinking, $config,
                         $context, $workspace, $mdDialog, ixaUserActions, dataGen, $location, TranslationService) {
    $scope.currentYear = AppConfiguration.get('copyRightYear');
    $scope.removeCopyRight = AppConfiguration.get('removeCopyRight');
    $scope.loginAllowed = BrowserSettings.cookiesEnabled;

    LoginService.getCustomLoginData($routeParams.value).then(function(data) {
        if(isEmpty(data)) {
            $redirect.redirectTo(null, $config.loginRoute);
        }
        else {
            $scope.data = data;
            $context.comIdForThemes.value = $scope.data.clientComIdForThemes;
            $workspace.activateWorkspace('shop');
            cookieService.setCookie("loginPage", $routeParams.value);
            LoginService.prepareLogin(dialogFunction);
        }
    });

    var isEmpty = function isEmpty(ob) {
        for (var i in ob) {
            if (ob.hasOwnProperty(i)) {
                return false;
            }
        }
        return true;
    };

    $scope.imprintURL = AppConfiguration.get('imprintURL');
    $scope.privacyPolicy = AppConfiguration.get('privacyPolicy');
    $scope.generalTerms = AppConfiguration.get('generalTerms');

    $scope.openDialog = function (ev, link, title) {
        LegalLinking.openDialog(ev, link, title);
    };

    function dialogFunction() {
        if ($location.path().indexOf("register") > -1) {
            TranslationService.initializeWithLanguage(dataGen, TranslationService.getCurrentLanguage()).then(function () {
                ixaUserActions.openUserRegistrationDialog($scope.data.clientComId, $scope.data.logo).then(function (answer) {
                    TranslationService.reset(dataGen);
                    $mdDialog.show({
                        multiple: true,
                        templateUrl: './modules/login/templates/login.tmpl.html',
                        controller: 'LoginDialogController',
                        controllerAs: "loginCtrl",
                        clickOutsideToClose: false,
                        escapeToClose: false,
                        fullscreen: false,
                        bindToController: true,
                        locals: {
                            customLogoURL: $scope.data.logo,
                            customHash: $routeParams.value,
                            customLoginTranslations: $scope.data.loginTranslations,
                            clientCompanyId: $scope.data.clientComId,
                            customLinks: $scope.data.customLinks
                        },
                        onComplete: function (scope) {
                            scope.dialogData.password.$setValidity("cookiesDisabled", BrowserSettings.cookiesEnabled);
                            scope.isLoaded = true;
                        }
                    });
                })
            });
        }
        else {
            $mdDialog.show({
                multiple: true,
                templateUrl: './modules/login/templates/login.tmpl.html',
                controller: 'LoginDialogController',
                controllerAs: "loginCtrl",
                clickOutsideToClose: false,
                escapeToClose: false,
                fullscreen: false,
                bindToController: true,
                locals: {
                    customLogoURL: $scope.data.logo,
                    customHash: $routeParams.value,
                    customLoginTranslations: $scope.data.loginTranslations,
                    clientCompanyId: $scope.data.clientComId,
                    customLinks: $scope.data.customLinks
                },
                onComplete: function (scope) {
                    scope.dialogData.password.$setValidity("cookiesDisabled", BrowserSettings.cookiesEnabled);
                    scope.isLoaded = true;
                }
            });
        }
    }
}